<template>
  <a-modal title="详情" :visible="showTubeView" :width="800" destroyOnClose @ok="handleOk" @cancel="closeTubeView">
    <a-modal
      title="地图"
      style="top: 20px"
      :width="800"
      v-model="mapVisible"
      @ok="mapVisible = false"
      @cancel="mapVisible = false"
    >
      <lonlat-map ref="lonlatMaps" @handleMapOk="handleMapOk"></lonlat-map>
    </a-modal>
    <a-row style="margin-top: 20px">
      <a-col :span="12">任务名称：{{ addOrUpdat.taskName }}</a-col>
      <a-col :span="12">任务编号：{{ addOrUpdat.taskNumber }}</a-col>
    </a-row>
    <a-row style="margin-top: 20px">
      <a-col :span="12">任务类型：{{ addOrUpdat.taskType }}</a-col>
      <a-col :span="12">发布人：{{ addOrUpdat.publisherName }}</a-col>
    </a-row>
    <a-row style="margin-top: 20px">
      <a-col :span="12">关联事件：{{ addOrUpdat.eventNo }}</a-col>
      <a-col :span="12">创建时间：{{ addOrUpdat.createTime }}</a-col>
    </a-row>
    <a-row style="margin-top: 20px">
      <a-col :span="12">负责人：{{ addOrUpdat.principalName }}</a-col>
      <a-col :span="12">协办人：{{ addOrUpdat.assistPersonName }}</a-col>
    </a-row>
    <a-row style="margin-top: 20px">
      <!-- <a-col :span="12">完成时间：{{ addOrUpdat.endTime }}</a-col> -->
      <a-col :span="12"
        >状态:
        <a-tag color="rgb(255, 99, 71)" v-if="addOrUpdat.status == 0">未开始</a-tag>
        <a-tag color="#f98303" v-if="addOrUpdat.status == 1">执行中</a-tag>
        <a-tag color="#40a9ff" v-if="addOrUpdat.status == 2">已提交</a-tag>
        <a-tag color="rgb(50, 205, 50" v-if="addOrUpdat.status == 3">已完成</a-tag>
      </a-col>
    </a-row>
    <a-row style="margin-top: 20px">
      <a-col :span="12">片区：{{ addOrUpdat.zoneName }}</a-col>
      <a-col :span="12"
        >发生地址：<span @click="addAddres" style="color: blue">{{ addOrUpdat.address }}</span></a-col
      >
    </a-row>
    <a-row style="margin-top: 20px">
      <a-col :span="12">任务描述：{{ addOrUpdat.description }}</a-col>

      <a-col :span="12">轨迹行程: <a-button type="primary" @click="checkTrack">查看</a-button></a-col>
    </a-row>
    <a-row style="margin-top: 20px">
      <a-col :span="12"
        >计划开始时间：
        <span v-if="addOrUpdat.predictStime !== null">{{
          moment(addOrUpdat.predictStime).format('YYYY-MM-DD')
        }}</span></a-col
      >
      <a-col :span="12"
        >计划处理时长: <span v-if="addOrUpdat.planTime !== null">{{ addOrUpdat.planTime }} 天</span></a-col
      >
    </a-row>
    <a-row style="margin-top: 20px">
      <a-col :span="12"
        >开始时间：
        <span v-if="addOrUpdat.startTime !== null">{{ moment(addOrUpdat.startTime).format('YYYY-MM-DD') }}</span></a-col
      >
      <a-col :span="12">处理时长：{{ addOrUpdat.processingTime }}</a-col>
    </a-row>
    <a-row style="margin-top: 20px">
      <a-col :span="12">处理结果：{{ addOrUpdat.draftConsequence }}</a-col>
      <a-col :span="12">描述：{{ addOrUpdat.draftNoteContent }}</a-col>
    </a-row>
    <a-row style="margin-top: 20px">
      <a-col :span="12">
        <div class="fileDiv">
          完成图片：
          <ul>
            <li class="fileLi" v-for="item in addOrUpdat.draftCompleteFileNames" :key="item.url">
              <img :src="item.url" alt="" style="width: 80px; height: 80px" @click="clicimg(item.url)" />
            </li>
          </ul>
        </div>
      </a-col>
      <a-col :span="12"> </a-col>
    </a-row>
    <a-row style="margin-top: 20px">
      <a-col :span="12"
        >处理记录：
        <a-form-model-item label="" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
          <a-timeline>
            <a-timeline-item v-for="item in addOrUpdat.records" :key="item.id">
              <span>{{ item.createTime }}</span>
              <span style="color: blue; margin-left: 20px">{{ item.name }}</span>
              <span style="margin-left: 10px">{{ item.message }}</span>
            </a-timeline-item>
          </a-timeline>
        </a-form-model-item></a-col
      >
      <a-col :span="12"></a-col>
    </a-row>
    <track-travel ref="TrackTravel"></track-travel>
    <a-modal
      title="图片"
      style="top: 20px"
      :width="800"
      :footer="null"
      :visible="visiblest"
      :confirm-loading="confirmLoading"
      @cancel="handleCancelhlg"
    >
      <img :src="this.pumpUrlg" :alt="this.pumpUrlg" style="width: 100%; height: 100%" />
    </a-modal>
  </a-modal>
</template>
<script>
import moment from 'moment'
import addModal from './AddModal'
// import TravelMap from './TravelMap'
import TrackTravel from './TrackTravel'
import LonlatMap from '../../../maintenance/EventManagement/modules/lonlatMap.vue'
export default {
  components: {
    addModal,
    // TravelMap,
    TrackTravel,
    LonlatMap,
  },
  props: {},
  data() {
    return {
      confirmLoading: false,
      mapVisible: false,
      queryOneUrl: '/pipe-network/inspection_tasks/',
      queryUrl: '/pipe-network/user_water_meters/page/geophysical-point-numbers',
      addOrUpdateUrl: '/pipe-network/inspection_tasks',
      exportFileName: '影响用户数据.xlsx',
      exportDataUrl: 'pipe-network/user_water_meters/export',
      showTubeView: false,
      id: '',
      showSmallMap: false,
      visiblest: false,
      pumpUrlg: '',
      addOrUpdat: {},
      addOrUpdateForm: {
        id: '',
        taskType: '',
        startTime: '',
        zoneId: '',
        description: '',
        address: '',
        assistPersons: [],
        principal: '',
        eventNo: '',
        endTime: '',
      },
      eventTypeList: [],
      assistPersonsList: [],
      currentId: '',
    }
  },
  computed: {
    rules() {
      return {}
    },
  },
  created() {},
  methods: {
    //缩略图
    clicimg(i) {
      this.pumpUrlg = i
      this.visiblest = true
    },
    handleCancelhlg() {
      this.visiblest = false
      this.pumpUrlg = ''
    },
    moment,
    //地图
    addAddres() {
      this.mapVisible = true
      if (this.addOrUpdat.place) {
        var pointData = this.addOrUpdat.place.split(',')
        var newPointData = pointData.map((item) => {
          return (item = parseFloat(item))
        })
        console.log(newPointData, this.$refs) // [113.678351, 25.538859]
        this.$nextTick(() => {
          this.$refs.lonlatMaps.changepoint(newPointData)
        })
      } else {
        this.$nextTick(() => {
          this.$refs.lonlatMaps.changepoint([0, 0])
        })
      }
    },
    moment,
    handleChange(value) {
      this.addOrUpdateForm.principal = value
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    addPepople(list) {
      this.assistPersonsList = list
      this.addOrUpdateForm.assistPersons = []
      list.map((item) => {
        this.addOrUpdateForm.assistPersons.push(item.key)
      })
    },
    openSmallMap() {
      this.showSmallMap = true
    },
    checkTrack() {
      console.log(this.addOrUpdateForm.id)
      this.$refs.TrackTravel.edit(this.addOrUpdateForm.id)
    },
    handleOk2(e) {
      e.preventDefault()
      this.showSmallMap = false
    },
    handleOk(e) {
      e.preventDefault()
      this.closeTubeView()
    },
    _updateForm(real, data) {
      let keys = Object.keys(real)
      let dataKeys = Object.keys(data)
      let newObject = {}
      keys.map((key) => {
        if (dataKeys.includes(key)) {
          newObject[key] = data[key]
        } else {
          newObject[key] = real[key]
        }
      })
      return newObject
    },
    edit(id) {
      this.showTubeView = true
      this.currentId = id
      this.addOrUpdateForm = {
        id: this.currentId,
        taskType: '',
        startTime: '',
        zoneId: '',
        description: '',
        address: '',
        assistPersons: [],
        principal: '',
        zoneName: '',
        eventNo: '',
      }

      this.$nextTick(() => {
        if (id) {
          this.isUpdate = true
          this.$http
            .get(`${this.queryOneUrl}/${this.currentId}`)
            .then(({ data }) => {
              
              // this.addOrUpdateForm = { ...this._updateForm(this.addOrUpdateForm, data) }
              this.addOrUpdat = data
            })
            .catch(() => {})
        }
      })
    },
    closeTubeView() {
      this.showTubeView = false
      this.assistPersonsList = []
    },
    // addAddres() {
    //   this.mapVisibles = true
    //   if (this.detail.locationInformation) {
    //     var pointData = this.detail.locationInformation.split(',')
    //     var newPointData = pointData.map((item) => {
    //       return (item = parseFloat(item))
    //     })
    //     console.log(newPointData, this.$refs) // [113.678351, 25.538859]
    //     this.$nextTick(() => {
    //       this.$refs.lonlatMaps.changepoint(newPointData)
    //     })
    //   } else {
    //     this.$nextTick(() => {
    //       this.$refs.lonlatMaps.changepoint([0, 0])
    //     })
    //   }
    // },
    handleMapOk() {},
  },
}
</script>

<style lang="less" scoped>
/deep/.ant-timeline {
  margin: 24px;
}
</style>
